/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import type { UTagData } from '@/types';
import { isServer } from '@/utils/isServer';

export function analyticsDataLayerVariable(data: Partial<UTagData>) {
  if (isServer) {
    return;
  }

  window.utag_data = { ...window.utag_data, ...data };
}
